import React, { Component } from 'react';
import { memoize } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods, CurrencyFormats } from '@sm360/widget-commons-vehicle';
import { PurchaseTerm } from '@sm360/widget-commons-tiles';

import CatalogTitleService from '../../../../services/CatalogTitleService.js';

import './PaymentInformation.scss';

const { PurchaseMethodsService } = PurchaseMethods;

class PaymentInformation extends Component {
    constructor(props) {
        super(props);
        this.payment = memoize((payment) => LocaleService.l(payment, CurrencyFormats.CURRENCY_2));
        this.taxPayments = memoize((taxPayments) => LocaleService.l(taxPayments, CurrencyFormats.CURRENCY_2));
        this.totalPayment = memoize((totalPayment) => LocaleService.l(totalPayment, CurrencyFormats.CURRENCY_2));
        this.cashdown = memoize((cashdown) => LocaleService.l(cashdown, CurrencyFormats.CURRENCY_2));
    }

    render() {
        const { purchaseTerm, purchaseMethod } = this.props;

        const calculatedPaymentSplit = PurchaseMethodsService.getFormattedCurrencySplit(
            this.payment(purchaseTerm.payment)
        );
        const apr = purchaseTerm.rate || 0;
        const purchaseMethodLabel = CatalogTitleService.getPurchaseMethodLabel(purchaseMethod);
        const paymentFrequencyLabel = CatalogTitleService.getPaymentFrequencyLabel(purchaseTerm.paymentFreq);

        const cashDown = purchaseTerm.cashdown || 0;

        const aprBloc = (
            <div className="rate">
                {apr.toFixed(2).split('.')[0]}
                <sup>{apr.toFixed(2).split('.')[1]}%</sup>
            </div>
        );

        const cashDownClass = ['vehicle-payment-cashdown'];
        if (cashDown === 0) {
            cashDownClass.push('zero');
        }

        const taxPayments = purchaseTerm.taxesDetails.paymentTaxes;
        const taxCodes = purchaseTerm.taxesDetails.taxesDetail;

        const taxesDetail =
            purchaseTerm.payment > 0 ? (
                <div className="taxes-detail">
                    <span className="highlight is-price">
                        <span>{this.payment(purchaseTerm.payment)}</span>
                    </span>
                    <span> + </span>
                    <span>{this.taxPayments(taxPayments)} </span>
                    <span>{taxCodes}</span>
                    <span> = </span>
                    <span>{this.totalPayment(purchaseTerm.taxesDetails.totalPayment)}</span>
                </div>
            ) : null;

        const paymentElement = (
            <div>
                <div className="vehicle-payment-title">
                    {LocaleService.t('TILE_A.FINANCE_TITLE', {
                        purchaseMethod: purchaseMethodLabel,
                    })}
                </div>
                <div className="vehicle-payment-wrapper clearfix">
                    <div className="vehicle-payment-amount is-bold is-price">
                        <span>
                            {calculatedPaymentSplit.beforeDecimal}
                            <sup>{calculatedPaymentSplit.afterDecimal}</sup>
                            <span className="vehicle-payment-amount-note">({paymentFrequencyLabel})</span>
                        </span>
                        {taxesDetail}
                    </div>
                    <div className="vehicle-payment-rate">
                        {aprBloc}
                        <div className="vehicle-payment-rate-note">
                            {`${purchaseTerm.term} ${LocaleService.t('TILE_A.MONTH')}`}
                        </div>
                    </div>
                    <div className={cashDownClass.join(' ')}>
                        {this.cashdown(cashDown)} {LocaleService.t('TILE_A.CASH_DOWN')}
                    </div>
                </div>
            </div>
        );

        return (
            <div className="vehicle-payment">
                {purchaseTerm.term > 0 ? (
                    paymentElement
                ) : (
                    <div className="notAvailable">{LocaleService.t('TILE_A.NOT_AVAILABLE')}</div>
                )}
            </div>
        );
    }
}

PaymentInformation.propTypes = {
    purchaseTerm: React.PropTypes.instanceOf(PurchaseTerm).isRequired,
    purchaseMethod: React.PropTypes.number.isRequired,
};

PaymentInformation.displayName = 'PaymentInformation';

export default PaymentInformation;



// WEBPACK FOOTER //
// /builds/development/frontend/widgets/widgets/components/tiles/tile-a/src/components/Tile/Catalog/sections/PaymentInformation.jsx